export const getUnreconciledTransactionsBadgeColor = (unreconciledTransactionCount: number) => {
  if (unreconciledTransactionCount > 20) {
    return 'error';
  }
  if (unreconciledTransactionCount > 10) {
    return 'warning';
  }
  return 'success';
};
